/* SkyDrift V2 : le moteur de l'accueil.
   Un seul ecouteur de defilement pilote tout ce qui suit la molette :
   l'ouverture (film), les bandes, le garage et le manifeste.

   Horizon fait defiler .page-wrapper au-dela de 900 px et la fenetre en
   dessous : on ecoute donc tous les defilements (phase de capture) et on
   mesure chaque bloc par rapport a l'ecran avec getBoundingClientRect.
   Le CSS est dans skydrift-v2.css. */
(function () {
  if (window.__skydriftV2) return;
  window.__skydriftV2 = true;

  const calme = matchMedia("(prefers-reduced-motion: reduce)").matches;
  // un telephone se reconnait a son doigt, jamais a sa largeur
  const tactile = matchMedia("(hover: none) and (pointer: coarse)").matches;
  const borne = (v, a, b) => Math.min(Math.max(v, a), b);
  // 0 quand le haut du bloc touche le haut de l'ecran, 1 quand son bas touche le bas
  const avance = el => {
    const r = el.getBoundingClientRect(), course = r.height - innerHeight;
    return course > 0 ? borne(-r.top / course, 0, 1) : (r.top < 0 ? 1 : 0);
  };
  const acteurs = [];

  /* ------------------------------------------------------- l'ouverture */
  document.querySelectorAll("[data-ouverture]").forEach(bloc => {
    const canvas = bloc.querySelector("canvas");
    const mot = bloc.querySelector("[data-mot]");
    const copie = bloc.querySelector("[data-copie]");
    const liste = bloc.dataset.images ? JSON.parse(bloc.dataset.images) : [];

    if (tactile || calme || !liste.length || !canvas) {
      bloc.classList.add("fixe");     // l'affiche reste, rien ne charge
      return;
    }
    const ctx = canvas.getContext("2d");
    const BG = "#0a0a0f";
    const images = [];
    let courante = -1, voulue = 0;

    const peint = () => {
      const src = images[courante];
      if (!src || !src.naturalWidth) return;
      const cw = canvas.width, ch = canvas.height;
      const etroit = innerWidth <= 900;
      ctx.fillStyle = BG;
      ctx.fillRect(0, 0, cw, ch);
      const e = cw / src.naturalWidth * (etroit ? 1.25 : 0.74);
      const dw = src.naturalWidth * e, dh = src.naturalHeight * e;
      const cx = (etroit ? 0.5 : 0.63) * cw, cy = (etroit ? 0.42 : 0.5) * ch;
      ctx.drawImage(src, cx - dw / 2, cy - dh / 2, dw, dh);
      // le projecteur : le bord du metrage (cyclo blanc) meurt dans le noir
      const R = dh / 2, SX = dw / dh;
      ctx.save();
      ctx.translate(cx, cy);
      ctx.scale(SX, 1);
      const g = ctx.createRadialGradient(0, 0, 0, 0, 0, R);
      g.addColorStop(0.00, "rgba(10,10,15,0)");
      g.addColorStop(0.45, "rgba(10,10,15,0)");
      g.addColorStop(0.64, "rgba(10,10,15,.5)");
      g.addColorStop(0.86, "rgba(10,10,15,.95)");
      g.addColorStop(1.00, "rgba(10,10,15,1)");
      ctx.fillStyle = g;
      ctx.fillRect(-cw * 4 / SX, -ch * 4, cw * 8 / SX, ch * 8);
      ctx.restore();
      bloc.classList.add("pret");
    };
    const dimensionne = () => {
      const dpr = Math.min(devicePixelRatio || 1, 2);
      canvas.width = innerWidth * dpr;
      canvas.height = innerHeight * dpr;
      peint();
    };
    liste.forEach((src, i) => {
      const im = new Image();
      // Safari ne livre pas dans l'ordre : on peint des que l'image attendue arrive
      im.onload = () => { if (i === voulue) { courante = i; peint(); } };
      im.src = src;
      images[i] = im;
    });
    addEventListener("resize", dimensionne);
    dimensionne();

    acteurs.push(() => {
      const p = avance(bloc);
      const i = Math.min(Math.floor(p * liste.length), liste.length - 1);
      voulue = i;
      if (i !== courante && images[i] && images[i].complete && images[i].naturalWidth) { courante = i; peint(); }
      // le mot traverse l'ecran ; le texte s'efface dans le premier quart
      if (mot) mot.style.setProperty("--x", (6 - p * 120) + "vw");
      // le film s'eteint a la toute fin seulement : pas d'ecran vide avant la bande
      canvas.style.opacity = p > 0.9 ? borne((1 - p) * 10, 0, 1) : "";
      if (copie) {
        copie.style.opacity = borne(1 - p * 5, 0, 1);
        copie.style.visibility = p > 0.22 ? "hidden" : "";
      }
    });
  });

  /* --------------------------------------------------------- la bande
     Elle n'avance que si la page avance : son decalage suit la position du
     bloc a l'ecran. Rien ne bouge tout seul, rien ne retient le defilement. */
  if (!calme) document.querySelectorAll("[data-bande]").forEach(el => {
    const piste = el.querySelector("[data-piste]"), sens = parseFloat(el.dataset.bande) || 1;
    acteurs.push(() => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > innerHeight + 100) return;
      piste.style.transform = "translate3d(" + (sens * (r.top - innerHeight) * 0.45) + "px,0,0)";
    });
  });

  /* --------------------------------------------------------- le garage
     Sur ordinateur, la descente fait glisser les voitures de cote. Au doigt,
     on les empile : on les voit toutes en descendant, sans geste cache. */
  document.querySelectorAll("[data-garage]").forEach(bloc => {
    if (tactile) { bloc.classList.add("libre", "empile"); return; }
    if (calme) { bloc.classList.add("libre"); return; }
    const piste = bloc.querySelector("[data-piste]");
    let course = 0;
    const mesure = () => {
      course = Math.max(piste.scrollWidth - innerWidth, 0);
      bloc.style.height = (course + innerHeight) + "px";
    };
    addEventListener("resize", mesure);
    addEventListener("load", mesure);
    mesure();
    acteurs.push(() => {
      piste.style.transform = "translate3d(" + (-avance(bloc) * course) + "px,0,0)";
    });
  });

  /* ------------------------------------------------------- le manifeste
     La phrase defile avec la page ; ses mots s'allument un par un pendant
     qu'elle remonte, du bas de l'ecran jusqu'au tiers haut. */
  document.querySelectorAll("[data-manifeste]").forEach(bloc => {
    const mots = Array.from(bloc.querySelectorAll("[data-m]"));
    if (calme) { mots.forEach(m => m.style.opacity = 1); return; }
    acteurs.push(() => {
      // tout est allume un peu avant la fin, pour qu'on ait le temps de lire
      const r = bloc.querySelector(".sd-manif__texte").getBoundingClientRect();
      const p = borne((innerHeight * 0.9 - r.top) / (innerHeight * 0.55), 0, 1);
      const allumes = p * 1.15 * mots.length;
      mots.forEach((m, i) => { m.style.opacity = borne(allumes - i, 0.14, 1); });
    });
  });

  /* ---------------------------------------- l'en-tete sur fond clair
     Le logo et le menu sont blancs : quand une section claire passe sous
     l'en-tete, il bascule en encre sombre (.on-light, dans skydrift.css). */
  const entete = document.querySelector(".site-header");
  const clairs = document.querySelectorAll("[data-clair]");
  // sur les fiches l'en-tete a son propre fond sombre : il garde son encre claire
  const transparent = entete && /rgba\(0, 0, 0, 0\)|transparent/.test(getComputedStyle(entete).backgroundColor);
  if (entete && transparent && clairs.length) {
    const sous = new Set();
    const oeil = new IntersectionObserver(es => {
      es.forEach(e => e.isIntersecting ? sous.add(e.target) : sous.delete(e.target));
      entete.classList.toggle("on-light", sous.size > 0);
    }, { rootMargin: "0px 0px -94% 0px" });
    clairs.forEach(c => oeil.observe(c));
  }

  if (!acteurs.length) return;
  let attente = false;
  const tick = () => {
    if (attente) return;
    attente = true;
    requestAnimationFrame(() => { attente = false; acteurs.forEach(a => a()); });
  };
  document.addEventListener("scroll", tick, { passive: true, capture: true });
  addEventListener("resize", tick);
  tick();
})();
